import { IconProp } from "@fortawesome/fontawesome-svg-core";
import {
  faFilePdf,
  faFileImage,
  faFile,
  faFileWord,
  faFileExcel
} from "@fortawesome/free-solid-svg-icons";

// Get appropriate icon for file type
export const getFileIcon = (fileType: string): IconProp => {
  if (fileType === 'application/pdf') return faFilePdf;
  if (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return faFileWord;
  if (fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return faFileExcel;
  if (fileType.includes('image')) return faFileImage;
  return faFile;
};

// Get appropriate color for file type
export const getFileTypeColor = (fileType: string): string => {
  if (fileType === 'application/pdf') return '#f44336';
  if (fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') return '#2196f3';
  if (fileType === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return '#4caf50';
  if (fileType.includes('image')) return '#ff9800';
  return '#757575';
};